import { Helmet } from "react-helmet-async";
import styles from "./About.module.css";
import { useTranslation } from "react-i18next";
import { url } from "../../baseUrl.js";
import heroImage from "../../assets/creater.webp";
import { useEffect } from "react";
const About = () => {
  //   const videoSrc = "/videos/presentation.mp4"; // Замените на путь к вашему видео
  const { i18n, t } = useTranslation();
  const lang = i18n.language || "en";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{t("about.seoTitle")}</title>
        <meta name="description" content={t("about.seoDescription")} />
        <meta
          name="keywords"
          content="music lessons, online teacher, piano, violin, Austria, music platform, Dmitry, music education"
        />
        <meta name="author" content="MusicTeacher4You" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={t("about.seoTitle")} />
        <meta property="og:description" content={t("about.seoDescription")} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`$/${lang}/about`} />
        <meta property="og:image" content={`${heroImage}?w=1200&h=630`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={`${heroImage}?w=1200&h=630`} />
        <link rel="canonical" href={`${url}/${lang}/about`} />
        <link rel="alternate" hreflang="en" href={`${url}/en/about`} />
        <link rel="alternate" hreflang="de" href={`${url}/de/about`} />
        <link rel="alternate" hreflang="x-default" href={`${url}/en/about`} />
        <link
          rel="preload"
          as="image"
          href={`${heroImage}?w=800`}
          type="image/webp"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: t("about.seoTitle"),
            description: t("about.seoDescription"),
            url: `${url}/${lang}/about`,
            publisher: {
              "@type": "Organization",
              name: "MusicTeacher4You",
              logo: {
                "@type": "ImageObject",
                url: `${url}/logo.png`,
              },
            },
            potentialAction: {
              "@type": "SearchAction",
              target: `${url}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          })}
        </script>
      </Helmet>

      <section
        className={styles.about}
        role="region"
        aria-labelledby="aboutTitle"
      >
        <div className={styles.container}>
          <h1 id="aboutTitle" className={styles.title}>
            {" "}
            {t("about.title")}
          </h1>

          <div className={styles.hero}>
            <img
              src={`${heroImage}?w=800`}
              srcSet={`${heroImage}?w=300 300w, ${heroImage}?w=800 800w, ${heroImage}?w=1200 1200w`}
              sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px"
              alt={t("about.photoAlt")}
              className={styles.photo}
            />
          </div>

          <div className={styles.content}>
            <h2>{t("about.myStory")}</h2>
            <p>{t("about.myStoryText1")}</p>
            <p>{t("about.myStoryText2")}</p>

            <h2>{t("about.platform")}</h2>
            <p>{t("about.platformText1")}</p>
            <p>{t("about.platformText2")}</p>

            <h2>{t("about.mission")}</h2>
            <p>{t("about.missionText")}</p>

            <h2>{t("about.whyImportant")}</h2>
            <p>{t("about.whyImportantText")}</p>

            <h2>{t("about.promise")}</h2>
            <p>{t("about.promiseText")}</p>
          </div>
          {/* 
          <div className={styles.videoSection}>
            <h2>{t("about.videoTitle")}</h2>
            <video
              title={t("about.videoTitle")}
              aria-label={t("about.videoTitle")}
              controls
              poster={`${heroImage}?w=800`}
              className={styles.video}
            >
              <track
                kind="captions"
                src={`/captions/${lang}.vtt`}
                srcLang={lang}
                label="Captions"
                default
              />
              {t("about.videoFallback")}
            </video>
          </div> */}

          <div className={styles.contact}>
            <h2>{t("about.contactTitle")}</h2>
            <div>
              <p>{t("about.contactText")}</p>
              <a
                aria-label={t("about.contactEmailLabel")}
                href="mailto:info@musicteacher4you.com"
                className={styles.contactLink}
              >
                info@musicteacher4you.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
